<form [formGroup]="rentalForm">
    <div *ngIf="!displayLayout">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4"></div>
            <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-right">
                
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4 text-left">
                <div class="card shadow mt-2">
                    <div class="card-header fw-700">
                        Event
                    </div>
                    <select class="form-control" formControlName="eventId" (change)="getEventMarketDays()">
                        <option *ngFor="let item of eventList" [value]="item.EventID">{{item.EventName}}</option>
                    </select>
                </div>
                <div class=" row mt-2" *ngIf="dailyEvent && totalEvent">
                    <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-left">
                        <div class="md-radio col-md-12 col-8">
                            <input type="radio" id="dailyEvent" name="eventOptions" value="1" formControlName="eventOptions" (change)="clearExistingData()">
                            <label for="dailyEvent" i18n>Daily Event</label>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-left">
                        <div class="md-radio col-md-12 col-8">
                            <input type="radio" id="totalEvent" name="eventOptions" value="2" formControlName="eventOptions" (change)="clearExistingData()">
                            <label for="totalEvent" i18n>Total Event</label>
                        </div>
                    </div>
                </div>
                <div class="card shadow mt-2">
                    <div class="card-header fw-700">
                        Event Market Day(s):
                    </div>
                    <ul class="list-group list-group-flush marketDates">
                        <li class="list-group-item" *ngFor="let item of eventMarketDays; let i=index">
                            <div class="form-check d-flex align-items-center">
                                <input class="form-check-input CheckboxClass" type="checkbox" [id]="'chk' + (i + 1)"
                                [checked]="this.rentalForm.get('eventOptions').value == '2'"
                                 [disabled]="this.rentalForm.get('eventOptions').value == '2'"
                                 (change)="checkboxChanged($event,item)">
                                <label class="form-check-label ml-2 mt-1" [attr.for]="'chk' + (i + 1)" i18n>
                                    {{item.MarketDays}}
                                </label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-right">
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4 mblRightToLeft mt-1">
                        <label class="mt-2 mb-0" for="marketParts">Select Layout Part</label>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-5 col-xl-5 mblRightToLeft mt-2">
                        <select class="form-control respLayoutPart" formControlName="marketParts" id="marketParts">
                            <option *ngFor="let item of parts" [value]="item.PartId">{{item.PartDescription}}</option>
                        </select>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3 mblRightToLeft mt-2">
                    <button class="btn btn-primary py-2" data-toggle="modal" data-target="#modalLayout"
                    (click)="openLayout()">Select Booth</button>
                    </div>
                </div>
                <div class="vendorDetails mt-2">
                    <ejs-grid #gridEvents [dataSource]='selectedBooths' class="Table_Height_store table-striped table-ipad"
                        [gridLines]='lines' height="150" allowSorting='true' [sortSettings]='sortOptions' [textWrapSettings]="textWrapSettings" allowTextWrap="true" >
                        <e-columns>
                            <e-column field='BoothNumber' headerText='Booth#' textAlign='left' width=75>
                            </e-column>
                            <e-column field='BoothType' headerText='Booth Type' textAlign='left' width=100>
                            </e-column>
                            <e-column field='Product' headerText='Product' width=210>
                                <ng-template #template let-data>
                                    <span class="dataName">
                                        <select class="form-control" [(ngModel)]="data.Product"
                                            [ngModelOptions]="{standalone: true}" (change)="productChange(data)">
                                            <option *ngFor="let item of vendorProducts" [value]="item.ProductId">
                                                {{item.ProductName}}</option>
                                        </select></span>
                                </ng-template>
                            </e-column>
                            <e-column field="EventDate" headerText="Event Date" width=150>
                                <ng-template #template let-data>
                                  <span class="dataName" *ngIf="data.TotalEvent">
                                    <select class="form-control" [(ngModel)]="data.EventDate"
                                            [ngModelOptions]="{standalone: true}">
                                      <option *ngFor="let item of data.TotalEventDays" [value]="item">
                                        {{ item }}
                                      </option>
                                    </select>
                                  </span>
                                  <span *ngIf="!data.TotalEvent">
                                    {{ data.EventDate }}
                                  </span>
                                </ng-template>
                              </e-column>
                              
                            <e-column field='EventRent' headerText='Event Rent' textAlign='right' width=120>
                            </e-column>
                            <e-column field='SalesTax' headerText='Sales Tax' textAlign='right' width=120>
                            </e-column>
                            <e-column field='CityTax' headerText='Sec Level Tax' textAlign='right' width=120>
                            </e-column>
                            <e-column field='EventName' headerText='Event Name' textAlign='left' width=120>
                            </e-column>
                            <e-column headerText='Delete' field="Delete" width=70>
                                <ng-template #template let-data let-index="index">
                                    <span class="Delete">
                                        <a class="colDelete" (click)="deleteSelectedBooth(data)"><img
                                                src="../assets/images/Delete_Icon.svg" class="img-fluid" [alt]="'Delete Icon '+index"
                                                style="max-width: 80% !important;" /></a>
                                    </span>
                                </ng-template>
                            </e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
                <div class="row" *ngIf="AllowRentingOtherItems">
                    <div class="col-12 text-right mt-2">
                        <button class="btn btn-primary btnAdd" (click)="openOtherChargeModal()">Select
                            Other Item</button>
                    </div>
                </div>
                <div class="vendorDetails mt-2" *ngIf="AllowRentingOtherItems">
                    <ejs-grid #gridEvtOtherRentals [dataSource]='selectedOtherItems'
                        class="Table_Height_store table-striped table-ipad" height='150' allowSorting='true'
                        [sortSettings]='sortOtherItemsOptions' [textWrapSettings]="textWrapSettings" allowTextWrap="true" >
                        <e-columns>
                            <e-column field='OtherItem' headerText='Item' textAlign='left' width=130>
                            </e-column>
                            <e-column field='OtherItemCharge' headerText='Charge' width=130>
                                <ng-template #template let-data *ngIf="overrideOtherChargesRent">
                                    <span class="dataName">
                                        <input type="text" class="form-control text-right pr-1"
                                            style="padding: 0px;" [disabled]="!data.NewItem"
                                            [(ngModel)]="data.OtherItemCharge"
                                            [ngModelOptions]="{standalone: true}"
                                            (blur)="updateOtherTotalRent(data)" appRemoveCurrencyFormatting data-auto-blur>
                                    </span>
                                </ng-template>
                            </e-column>
                            <e-column field='Quantity' headerText='Qty' width=100>
                                <ng-template #template let-data>
                                    <span class="dataName">
                                        <input type="text" (keydown)="onCheckNumKeyPress($event)"
                                            class="form-control" [disabled]="!data.NewItem"
                                            [(ngModel)]="data.Quantity" [ngModelOptions]="{standalone: true}"
                                            (blur)="updateOtherTotalRent(data)">
                                    </span>
                                </ng-template>
                            </e-column>
                            <e-column field='BoothNo' headerText='Booth#' width=100>
                            </e-column>
                            <e-column field="EventDate" headerText="Event Date" width=150>
                                <ng-template #template let-data>
                                  <span class="dataName" *ngIf="data.TotalEvent">
                                    <select class="form-control" [(ngModel)]="data.EventDate"
                                            [ngModelOptions]="{standalone: true}">
                                      <option *ngFor="let item of data.TotalEventDays" [value]="item">
                                        {{ item }}
                                      </option>
                                    </select>
                                  </span>
                                  <span *ngIf="!data.TotalEvent">
                                    {{ data.EventDate }}
                                  </span>
                                </ng-template>
                              </e-column>
                              <e-column field='OtherItemtotal' headerText='Total' textAlign="right" width=110>
                            </e-column>
                            <e-column field='SalesTax' headerText='Sales Tax' textAlign="right" width=120>
                            </e-column>
                            <e-column field='CityTax' headerText='Sec Level Tax' textAlign="right" width=140>
                            </e-column>
                            <e-column field='EventName' headerText='Event Name' textAlign='left' width=120>
                            </e-column>
                            <e-column field='Reference' headerText='Reference' width=160>
                                <ng-template #template let-data>
                                    <span class="dataName">
                                        <input type="text" class="form-control"
                                            (blur)="updateOtherItemReference(data)" [disabled]="!data.NewItem"
                                            [(ngModel)]="data.Reference" [ngModelOptions]="{standalone: true}">
                                    </span>
                                </ng-template>
                            </e-column>
                            <e-column headerText='Delete' field="Delete" width='80'>
                                <ng-template #template let-data let-index="index">
                                    <span class="Delete">
                                        <a class="colDelete" (click)="deleteOtherRentalCharges(data)"><img
                                                src="data:image/svg+xml;base64,PHN2ZyBpZD0iSWNvbl9tYXRlcmlhbC1kZWxldGUiIGRhdGEtbmFtZT0iSWNvbiBtYXRlcmlhbC1kZWxldGUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjE1LjIzNyIgaGVpZ2h0PSIxOS41OTEiIHZpZXdCb3g9IjAgMCAxNS4yMzcgMTkuNTkxIj4NCiAgPHBhdGggaWQ9Ikljb25fbWF0ZXJpYWwtZGVsZXRlLTIiIGRhdGEtbmFtZT0iSWNvbiBtYXRlcmlhbC1kZWxldGUiIGQ9Ik04LjU4OCwyMS45MTRhMi4xODMsMi4xODMsMCwwLDAsMi4xNzcsMi4xNzdoOC43MDdhMi4xODMsMi4xODMsMCwwLDAsMi4xNzctMi4xNzdWOC44NTNIOC41ODhaTTIyLjczNyw1LjU4OEgxOC45MjhMMTcuODQsNC41SDEyLjRMMTEuMzA5LDUuNTg4SDcuNVY3Ljc2NUgyMi43MzdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNy41IC00LjUpIiBmaWxsPSIjMTA2RUJFIi8+DQo8L3N2Zz4NCg=="
                                                [alt]="'Delete Icon Other Item '+index" class="img-fluid" style="max-width: 80% !important;" /></a>
                                    </span>
                                </ng-template>
                            </e-column>
                        </e-columns>
                    </ejs-grid>
                </div>

                <div class="vendorDetails1 mt-2">
                    <div class="float-right bottom_button mt-sm-2 w-100 d-flex" *ngIf="!newVendor">
                        <button type="button" i18n class="btn btnCancel mr-1" (click)="cancelRental()">Cancel</button>
                        <button type="button" i18n class="btn btn-primary" [disabled]="disableSavePayment()" (click)="saveRentalWithPayment()">Pay</button>
                    </div>
                    <div class="float-right bottom_button mt-sm-2 w-100 d-flex" *ngIf="newVendor">
                        <button type="button" i18n class="btn btnCancel mr-1" (click)="cancelRental()">Cancel</button>
                        <button type="button" i18n class="btn btn-primary" [disabled]="disableSavePayment()" (click)="rentOnlineNextTab()">Next</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>

<div *ngIf="displayLayout">
    <app-rentallayout-online [marketId]="marketId" [layoutParts]="layoutParts" rentalType="D"
        (selectedBoothsFromLayout)="selectedBoothsFromLayout($event)" (CloseLayout)="closeLayoutForm()"
        (removeBoothCharges)="removeBoothCharges($event)"></app-rentallayout-online>
</div>

<div class="modal fade bd-example-modal-xl" #modalOtherCharges id="modalOtherCharges" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content contentNewBooths">
            <div class="modal-header modal-headerNewBooths">
                <h2 class="modal-title" id="exampleModalCenterTitle" i18n>Other Charges</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body modal-bodyNewBooths">
                <div class="row mt-2">
                    <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2 text-left">
                        <label for="otherItemSearchText">Search Value</label>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4 text-left">
                        <input type="text" id="otherItemSearchText" class="form-control" [(ngModel)]="otherItemSearchText"
                            (keyup)="searchOtherItem()">
                    </div>
                </div>
                <div class="row" style="height: 46vh;overflow-y: scroll;">
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right mt-2">
                        <div class="availableBoothsHeading pt-1 pb-1">
                            <span i18n>Other Charges</span>
                        </div>
                        <div class="scroll_outer">
                                <table class="table table-striped table-hover followup-table mb-0">
                                    <thead>
                                        <tr>
                                            <th class="text-left tblAvailableBooths" width="40" i18n><Span class="invisible">7</Span></th>
                                            <th class="text-left tblAvailableBooths" width="140" i18n>Items</th>
                                            <th class="text-left tblAvailableBooths" width="100"
                                                *ngIf="displayOtherChargeByBooth" i18n>Booth#</th>
                                            <th class="text-left tblAvailableBooths" width="120" i18n>Charges</th>
                                            <th class="text-left tblAvailableBooths" width="90" i18n>Qty</th>
                                            <th class="text-center tblAvailableBooths" width="100" i18n>Total</th>
                                            <th class="text-left tblAvailableBooths" width="130" i18n>Reference</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of otherRentalCharges">
                                            <td class="text-left">
                                                <label class="pure-material-checkbox">
                                                    <input type="checkbox" [checked]="isDateSelected(item)"
                                                        [(ngModel)]="item.select"
                                                        (change)="setDefaultRentalItem($event,item)">
                                                    <span></span>
                                                </label>
                                            </td>
                                            <td class="text-left">
                                                {{item.OtherItem}}</td>
                                            <th class="text-left tblAvailableBooths" style="width: 35%;"
                                                *ngIf="displayOtherChargeByBooth">
                                                <select class="form-control" [(ngModel)]="item.othChgBooths"
                                                    (change)="otherItemUpdate(item)"
                                                    [disabled]="!item.otherItemChecked">
                                                    <option value="none">None</option>
                                                    <option *ngFor="let booth of boothsForOtherCharge"
                                                        [value]="booth.BoothNumber">{{booth.BoothNumber}}</option>
                                                </select>
                                            </th>
                                            <td class="text-left">
                                                <input type="text" class="form-control mt-2 mb-2 text-right"
                                                    disabled=true
                                                    [(ngModel)]="item.OtherItemCharge"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (change)="otherItemUpdate(item)">
                                            </td>
                                            <td class="text-left"><input
                                                    type="number" [disabled]="!item.otherItemChecked"
                                                    class="form-control mt-2 mb-2" [(ngModel)]="item.Quantity" min="1"
                                                    onkeydown="return false" (ngModelChange)="otherItemUpdate(item)">
                                            </td>
                                            <td class="text-right">
                                                {{item.OtherItemtotal}}</td>
                                            <td class="text-left">
                                                <input type="text" class="form-control mt-2 mb-2"
                                                    [(ngModel)]="item.Reference" [disabled]="!item.otherItemChecked"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (keyup)="otherItemUpdate(item)">
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer d-block pt-1 pb-2">
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right mt-1">
                        <button class="btn btn-primary mr-1" (click)="addOtherCharges()" data-dismiss="modal"
                            aria-label="Close" i18n>OK</button>
                        <button class="btn btnCancel" data-dismiss="modal" aria-label="Close" i18n>Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Other Charge modal -->
<div class="modal fade bd-example-modal-xl" #modalOtherChargeOption id="modalOtherChargeOption" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md alignMarketDays" role="document">
        <div class="modal-content">
            <div class="modal-header modal-headerNewBooths">
                <h5 class="modal-title" id="exampleModalCenterTitle" i18n>Events</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="refreshAddBooth()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row"  *ngIf="dailyEvent && totalEvent">
                    <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-left">
                        <div class="md-radio col-md-12 col-8">
                            <input type="radio" id="dailyOtherEvent" name="dailyOtherEvent" value="1" 
                            [(ngModel)]="otherChargeEventType" (change)="changeOtherChargeEventType()">
                            <label for="dailyOtherEvent" i18n>Daily Event</label>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-left">
                        <div class="md-radio col-md-12 col-8">
                            <input type="radio" id="totalOtherEvent" name="totalOtherEvent" value="2" [(ngModel)]="otherChargeEventType"
                            (change)="changeOtherChargeEventType()">
                            <label for="totalOtherEvent" i18n>Total Event</label>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2 text-left" style="display: inline-block">
                        <label i18n>Event</label>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4 text-left" style="display: inline-block;">
                        <select class="form-control" [(ngModel)]="otherChargeEventId" (change)="getEventMarketDays()">
                            <option *ngFor="let item of eventList" [value]="item.EventID">{{item.EventName}}</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2 text-left">
                        <label i18n>Market Days</label>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-left">
                        <div class="divChkMarketDays" style="height: 130px;">
                            <div class="pt-1" *ngFor="let item of eventMarketDays; let i=index">
                                <div class="checkbox-wrapper mt-1">
                                    <label class="pure-material-checkbox ">
                                        <input type="checkbox" class="checkBoxClass"
                                        [checked]="this.rentalForm.get('eventOptions').value == '2'"
                                        [disabled]="this.rentalForm.get('eventOptions').value == '2'"
                                        (change)="otherChargeCheckboxChanged($event,item)">
                                        <span>{{item.MarketDays}}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer d-block pt-1 pb-0">
                    <div class="row">
                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right mt-2 mb-1">
                            <button class="btn btn-primary mr-1" (click)="openOtherChargeModal()">OK</button>
                            <button class="btn btnCancel" data-dismiss="modal" aria-label="Close"
                                (click)="refreshAddBooth()">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Other Charge modal-->

<!-- Modal for Resale Number -->
<div class="modal fade bd-example-modal-xl" #modalResaleNo id="modalResaleNo" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header modal-headerNewBooths">
                <h5 class="modal-title" id="exampleModalCenterTitle" *ngIf="ResaleOrBusinessHeader" i18n>{{ResaleOrBusinessHeader}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="closeResaleModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left" *ngIf="resaleNoDisplay">
                        <div class="checkbox-wrapper mt-2">
                            <label class="pure-material-checkbox">Resale Number is required!</label>
                        </div>
                        <hr class="my-3">
                        <div class="col-md-12 col-8 mt-2">
                            <label for="resaleNumberInput">Resale Number</label>
                            <input type="text" id="resaleNumberInput" class="form-control" [(ngModel)]="resaleNo" maxlength="30" />
                        </div>
                    </div>
                
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left" *ngIf="businessLicenseDisplay">
                        <div class="checkbox-wrapper mt-2">
                            <label class="pure-material-checkbox">Business License Number is required!</label>
                        </div>
                        <hr class="my-3">
                        <div class="col-md-12 col-8 mt-2">
                            <label for="businesLicenseNumberInp">Business License Number</label>
                            <input type="text" id="businesLicenseNumberInp" class="form-control" [(ngModel)]="businessLicenseNumber"
                                maxlength="30" />
                        </div>
                        <div class="col-md-12 col-8 mt-2">
                            <label for="businesLicenseExpDateInp">Business Expiry Date</label>
                            <input type="date" class="form-control" [(ngModel)]="businessLicenseExpiryDate"
                                [placeholder]="'Business License Expiry Date'" i18n-placeholder="Business License Expiry Date">
                        </div>
                    </div>
                </div>

                <div class="modal-footer d-block pt-1 pb-2">
                    <div class="row">
                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right mt-1">
                            <button class="btn btn-primary mr-1" data-dismiss="modal" aria-label="Close" i18n
                                (click)="AddBoothsOnGridOnValidationSucess()">OK</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Modal for Resale Number -->